class GazetaPixel extends Pixel
{
  onCollectionPageView (collection, products)
  {
    const items = [];

    products.forEach(product => {
      items.push({
        id: product.id,
        name: product.title,
        price: parseFloat(product.variants[0].price).toFixed(2),
        brand: product.vendor,
        category: product.product_type,
        quantity: 1
      });
    });

    c2cPixel('event', 'ProductList', {
      productsArray: items
    });
  }

  onFilterResult (collection, products)
  {
    const items = [];

    products.forEach(product => {
      items.push({
        id: product.id,
        name: product.title,
        price: parseFloat(product.variants[0].price).toFixed(2),
        brand: product.vendor,
        category: product.product_type,
        quantity: 1
      });
    });

    c2cPixel('event', 'ProductList', {
      productsArray: items
    });
  }

  onProductPageView (product, variant)
  {
    c2cPixel('event', 'ViewProduct', {
      id: product.id,
      name: product.title,
      price: (product.price / 100).toFixed(2),
      brand: product.vendor,
      category: product.type,
      oldPrice: ((product.compare_at_price + 0) / 100).toFixed(2)
    });
  }

  onCartAdd (product)
  {
    c2cPixel('event', 'AddToCart', {
      id: product.product_id,
      name: product.product_title,
      price: (product.price / 100).toFixed(2),
      category: product.product_type,
      quantity: product.quantity,
      brand: product.vendor,
    });
  }

  onCartOpen (cart)
  {
    const products = [];

    cart.items.forEach(item => {
      products.push({
        id: item.product_id,
        name: item.product_title,
        price: (item.price / 100).toFixed(2),
        category: item.product_type,
        quantity: item.quantity,
        brand: item.vendor,
      });
    });

    c2cPixel('event', 'ShowCart', {
      revenue: (cart.total_price / 100).toFixed(2),
      productsArray: products
    });
  }
}
